var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartmentBlack24Dp2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BBFD8857-DB77-4F09-B469-6CABBA4BEBC1@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CondoGo:-Icon-Library",
    transform: "translate(-32.000000, -514.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apartment_black_24dp",
    transform: "translate(32.000000, 514.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,11 L17,3 L7,3 L7,7 L3,7 L3,21 L11,21 L11,17 L13,17 L13,21 L21,21 L21,11 L17,11 Z M7,19 L5,19 L5,17 L7,17 L7,19 Z M7,15 L5,15 L5,13 L7,13 L7,15 Z M7,11 L5,11 L5,9 L7,9 L7,11 Z M11,15 L9,15 L9,13 L11,13 L11,15 Z M11,11 L9,11 L9,9 L11,9 L11,11 Z M11,7 L9,7 L9,5 L11,5 L11,7 Z M15,15 L13,15 L13,13 L15,13 L15,15 Z M15,11 L13,11 L13,9 L15,9 L15,11 Z M15,7 L13,7 L13,5 L15,5 L15,7 Z M19,19 L17,19 L17,17 L19,17 L19,19 Z M19,15 L17,15 L17,13 L19,13 L19,15 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentBlack24Dp2X);
export default __webpack_public_path__ + "static/media/apartment_black_24dp@2x.a8a43d403fa0247e568f49665df3db0a.svg";
export { ForwardRef as ReactComponent };